module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-600italic.woff?4e1036758ebde5e016b4b2c16294a3e6";